var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-wrapper"},[_c('el-menu',{staticClass:"el-menu-vertical",attrs:{"default-active":_vm.defaultActivePath}},[_vm._l((_vm.routes),function(route){return _c('SidebarItem',{key:route.name,attrs:{"item":route,"base-path":route.path}})}),_c('anchor-nav')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }